import React from 'react';
import {MainLayout} from 'components/layouts';
import FairAds from 'components/fair/FairAds.jsx';
import {Link} from 'react-router-dom';

class FairAdsPage extends React.Component {
  render() {
    return (
      <MainLayout>
        <div>
          <div className='mb15'>
            <Link className='btn-back' to={`/fair/${this.props.match.params.id}`}><i className='fa fa-chevron-left' />Quay về trang chi tiết</Link>
          </div>
          <FairAds params={this.props.match.params}/>
        </div>
      </MainLayout>
    );
  }
}

FairAdsPage.contextTypes = {
  router: React.PropTypes.object
};

export default FairAdsPage;


// WEBPACK FOOTER //
// ./pages/fair/FairAdsPage.jsx